module.exports = __webpack_public_path__ + "img/ElCamino1974.13546b44.jpg";